import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac64398c")

_pushScopeId("data-v-ac64398c")
const _hoisted_1 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "my-1 font-normal" }
const _hoisted_4 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "my-1 font-normal w-10/12" }
const _hoisted_7 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "my-1 font-normal" }
const _hoisted_10 = { class: "ql-editor" }
const _hoisted_11 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_12 = { class: "font-semibold mb-2" }
const _hoisted_13 = {
  key: 1,
  class: "my-1 font-normal w-8/12"
}
const _hoisted_14 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_15 = { class: "font-semibold mb-2" }
const _hoisted_16 = {
  key: 1,
  class: "font-normal w-8/12"
}
const _hoisted_17 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "my-1 font-normal w-8/12" }
const _hoisted_20 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "my-3 font-normal flex flex-wrap w-10/12 gap-3" }
const _hoisted_23 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { class: "my-1 font-normal w-8/12" }
const _hoisted_26 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_27 = { class: "font-semibold" }
const _hoisted_28 = { class: "my-1 font-normal" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "capitalize" }
const _hoisted_31 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_32 = { class: "font-semibold" }
const _hoisted_33 = { class: "my-1 font-normal" }
const _hoisted_34 = { class: "text-gray-lp-500" }
const _hoisted_35 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_36 = { class: "font-semibold" }
const _hoisted_37 = { class: "my-1 font-normal" }
const _hoisted_38 = { class: "text-gray-lp-500" }
const _hoisted_39 = {
  key: 0,
  class: "py-3 inline-flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_download_attachment = _resolveComponent("download-attachment")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ButtonOutline = _resolveComponent("ButtonOutline")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_modal_show_image = _resolveComponent("modal-show-image")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail,
      title: _ctx.detailData.name,
      isConfirm: _ctx.isConfirmDelete,
      onDelete: _ctx.onDelete,
      onConfirm: _ctx.onOpenDelete
    }, _createSlots({
      "sub-data": _withId(() => [
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("announcement.status")), 1),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("div", {
                class: ["rounded-full px-2 py-0 font-medium", _ctx.styleStatusBaseRates]
              }, [
                _createVNode("span", _hoisted_30, _toDisplayString(_ctx.detailData.status.toLowerCase() === "send"
                    ? _ctx.$t("announcement.statusSent")
                    : _ctx.detailData.status), 1)
              ], 2)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("announcement.createdAt")), 1),
          _createVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDateToString(_ctx.detailData.createdAt)), 1),
          _createVNode("div", _hoisted_34, _toDisplayString(_ctx.detailData.createdName), 1)
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("announcement.lastModified")), 1),
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatDateToString(_ctx.detailData.updatedAt || _ctx.detailData.createdAt)), 1),
          _createVNode("div", _hoisted_38, _toDisplayString(_ctx.detailData.updatedBy), 1)
        ]),
        (_ctx.isEditAble)
          ? (_openBlock(), _createBlock("div", _hoisted_39, [
              _createVNode(_component_button_fill, {
                onClick: _ctx.goEdit,
                title: _ctx.$t('announcement.edit'),
                class: "px-8 bg-red-lp-300 mr-2"
              }, null, 8, ["onClick", "title"]),
              _createVNode(_component_ButtonOutline, {
                onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenDelete(true)),
                icon: "delete",
                class: "px-8"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!_ctx.isLoading)
        ? {
            name: "data",
            fn: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("announcement.announcementId")), 1),
                _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailData.id), 1)
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("announcement.nameActivity")), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.firstCapitalizeString(_ctx.detailData.name)), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("announcement.description")), 1),
                _createVNode("div", _hoisted_9, [
                  _withDirectives(_createVNode("div", _hoisted_10, null, 512), [
                    [_directive_sanitize_html, _ctx.detailData.description]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("announcement.attachment")), 1),
                (_ctx.detailData.attachment)
                  ? (_openBlock(), _createBlock(_component_download_attachment, {
                      key: 0,
                      name: _ctx.detailData.attachment,
                      url: _ctx.detailData.attachment,
                      maxLength: 45
                    }, null, 8, ["name", "url"]))
                  : (_openBlock(), _createBlock("div", _hoisted_13, " - "))
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("announcement.banner")), 1),
                (_ctx.detailData.bannerImage)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.detailData.bannerImage,
                      class: "w-full h-48 cursor-pointer object-cover rounded",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOpenShowImage && _ctx.onOpenShowImage(...args))),
                      alt: ""
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("div", _hoisted_16, " - "))
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("announcement.releaseDate")), 1),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateToString(_ctx.detailData.releasedAt)), 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("announcement.target")), 1),
                _createVNode("div", _hoisted_22, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.announcementTarget, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex-col",
                      key: index
                    }, [
                      _createVNode(_component_Chips, {
                        label: item.userTarget,
                        class: item.userTarget === 'pos' ? 'uppercase' : 'capitalize'
                      }, null, 8, ["label", "class"])
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("announcement.pinnedMessage")), 1),
                _createVNode("div", _hoisted_25, _toDisplayString(_ctx.detailData.pinned ? _ctx.$t("announcement.pinnedYes") : "-"), 1)
              ])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain", "title", "isConfirm", "onDelete", "onConfirm"]),
    _withDirectives(_createVNode(_component_modal_show_image, {
      onClose: _ctx.onCloseShowImage,
      image: _ctx.detailData.bannerImage
    }, null, 8, ["onClose", "image"]), [
      [_vShow, _ctx.isShow]
    ])
  ], 64))
})